module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "project"
  }, [_c('div', {
    staticClass: "slideshow"
  }, [_c('transition-group', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.current === 0),
      expression: "current === 0"
    }],
    key: 0,
    staticClass: "slide title-slide"
  }, [_c('header', [_c('div', {
    staticClass: "bar serif"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })])])]), _vm._l((_vm.slides), function(slide, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.current === index + 1),
        expression: "current === index + 1"
      }],
      key: index + 1,
      staticClass: "slide"
    }, [_c('figure', [_c('div', {
      class: {
        'diptych': !_vm.empty(slide.image_2)
      },
      on: {
        "mouseenter": _vm.imgHover,
        "mouseleave": function($event) {
          _vm.imgHover(false)
        }
      }
    }, [(!_vm.empty(slide.image_1)) ? _c('img', {
      attrs: {
        "src": _vm.imgSrc(slide.image_1.url, _vm.isPortrait(slide.image_1)),
        "data-portrait": _vm.isPortrait(slide.image_1)
      }
    }) : _vm._e(), (!_vm.empty(slide.image_2)) ? _c('img', {
      attrs: {
        "src": _vm.imgSrc(slide.image_2.url, _vm.isPortrait(slide.image_2)),
        "data-portrait": _vm.isPortrait(slide.image_2)
      }
    }) : _vm._e()])])])
  })], 2)], 1), (_vm.preload) ? _c('div', {
    staticClass: "preload"
  }, [_vm._l((_vm.preload), function(item) {
    return [(!_vm.empty(item.image_1)) ? _c('img', {
      attrs: {
        "src": _vm.imgSrc(item.image_1.url, _vm.isPortrait(item.image_1))
      }
    }) : _vm._e(), (!_vm.empty(item.image_2)) ? _c('img', {
      attrs: {
        "src": _vm.imgSrc(item.image_2.url, _vm.isPortrait(item.image_2))
      }
    }) : _vm._e()]
  })], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6599fa2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Project.vue
// module id = 152
// module chunks = 1